import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query VimeoUserInfo ($id: ID!) {
      VimeoUserInfo (id: $id) {
        ...vimeoUserDetail
        pictures {
          ...vimeoPictureDetail
        }
        websites {
          ...vimeoWebsiteDetail
        }
        metadata {
          connections {
            videos {
              ...vimeoMetadataDetail
            }
          }
        }
      }
    }
    ${fragments.vimeoPictureDetail}
    ${fragments.vimeoUserDetail}
    ${fragments.vimeoMetadataDetail}
    ${fragments.vimeoWebsiteDetail}
  `
